const translations = {
  es: {
    // Meses
    'month.1': 'Enero',
    'month.2': 'Febrero',
    'month.3': 'Marzo',
    'month.4': 'Abril',
    'month.5': 'Mayo',
    'month.6': 'Junio',
    'month.7': 'Julio',
    'month.8': 'Agosto',
    'month.9': 'Septiembre',
    'month.10': 'Octubre',
    'month.11': 'Noviembre',
    'month.12': 'Diciembre',
    'day': 'Día',

    // Login layout — panel izquierdo
    'login.leftTitle': 'Gestión centralizada de la App PayFlex para empresas.',
    'login.leftSubtitle':
      'Pensada para el día a día de quienes trabajan junto a PayFlex. Gestiona tus colaboradores y demás desde un solo lugar.',
    'login.internalUse': 'Uso interno',
    'login.brandLabel': 'Empresas',

    // Login form
    'login.title': 'Iniciar sesión',
    'login.subtitle': 'Usa el mail y la contraseña de tu cuenta de administración.',
    'login.email': 'Email',
    'login.password': 'Contraseña',
    'login.passwordPlaceholder': 'contraseña',
    'login.showPassword': 'Mostrar contraseña',
    'login.hidePassword': 'Ocultar contraseña',
    'login.submit': 'Entrar',
    'login.loading': 'Iniciando sesión…',
    'login.troubleText': '¿Problemas para iniciar sesión?',
    'login.language': 'Idioma',

    // Login errores
    'login.error.emptyEmail': 'Indica el email de tu cuenta de administración.',
    'login.error.emptyPassword': 'Indica la contraseña.',
    'login.error.noPermission': 'No tienes permiso para acceder.',

    // Dashboard
    'dashboard.welcome.male': 'Bienvenido',
    'dashboard.welcome.female': 'Bienvenida',
    'dashboard.welcome': 'Bienvenido',
    'dashboard.subtitle': 'Aquí verás todos tus reportes',
    'dashboard.activeUsers': 'usuarios activos',
    'dashboard.withdrawnThisMonth': 'retirado este mes',
    'dashboard.withdrawnIn': 'retirado en {month}',
    'dashboard.withdrawalCount': 'cantidad de retiros',
    'dashboard.avgWithdrawal': 'promedio de retiro',
    'dashboard.chartTitle': 'Retiros - {month} {year}',

    // Navegación (Sidenav)
    'nav.home': 'Inicio',
    'nav.users': 'Usuarios',
    'nav.withdrawals': 'Retiros',
    'nav.addUsersSection': 'Agregar Usuarios',
    'nav.addUser': 'Agregar usuario',
    'nav.bulkUpload': 'Carga masiva',
    'nav.receiptsSection': 'Comprobantes de pago',
    'nav.attachReceipt': 'Adjuntar comprobante',
    'nav.downloadReceiptSection': 'Comprobantes de retiro',
    'nav.downloadReceipt': 'Descargar comprobantes',
    'nav.historySection': 'Historial',
    'nav.actionHistory': 'Historial de acciones',
    'nav.helpSection': 'Ayuda',
    'nav.support': 'Atención al cliente',
    'nav.settings': 'Ajustes',
    'nav.settingsSection': 'Configuración',

    // Cierre de sesión
    'logout.button': 'Cerrar sesión',
    'logout.dialog.title': 'Cerrar sesión',
    'logout.dialog.text': '¿Seguro que deseas cerrar sesión? Tendrás que volver a iniciar sesión para acceder al\npanel.',
    'logout.loading': 'Cerrando sesión…',
    'logout.loadingDesc': 'Estamos cerrando tu sesión de forma segura.',

    // Inicio de sesión (pantalla de carga)
    'session.loadingDesc': 'Estamos preparando tu acceso al panel.',
    'session.errorTitle': 'No se pudo iniciar sesión',
    'session.errorRedirect': 'Te redirigiremos al inicio de sesión en unos segundos.',

    // Ajustes
    'settings.title': 'Ajustes',
    'settings.subtitle': 'Personaliza tu experiencia en el panel.',
    'settings.changePhoto': 'Cambiar foto de perfil',
    'settings.photoError': 'No se pudo actualizar la foto. Intentá de nuevo.',
    'settings.languageSection': 'Idioma',
    'settings.languageDesc': 'Selecciona el idioma del panel y de los archivos generados.',
    'settings.languageSpanish': 'Español',
    'settings.languageEnglish': 'English',
    'settings.save': 'Guardar cambios',
    'settings.saved': 'Guardado correctamente',
    'settings.saving': 'Guardando...',
    'settings.errorSaving': 'Error al guardar. Se aplicó localmente.',
    'settings.actionHistory': 'Historial de acciones',
    'settings.actionHistoryDesc': 'Ver el registro de todas tus acciones en el panel.',

    // Retiros — UI
    'withdrawals.titleThisMonth': 'Retiros del mes',
    'withdrawals.titleOf': 'Retiros de {month}',
    'withdrawals.pageSubtitle': 'Visualizá los retiros realizados por tu equipo en el período seleccionado.',
    'withdrawals.search': 'Buscar por nombre o documento...',
    'withdrawals.month': 'Mes',
    'withdrawals.year': 'Año',
    'withdrawals.downloadPdf': 'Descargar PDF',
    'withdrawals.noData': 'No hubieron retiros en el mes',
    'withdrawals.table.name': 'Nombre',
    'withdrawals.table.document': 'Documento',
    'withdrawals.table.amount': 'Total Retirado',
    'withdrawals.table.movements': 'Movimientos',
    'withdrawals.table.date': 'Fecha',
    'withdrawals.table.status': 'Estado',
    'withdrawals.viewBtn': 'Ver retiros',

    // PDF Retiros
    'pdf.retiros.title': 'Historial de retiros de {month}',
    'pdf.retiros.support': 'PayFlex | support@payflexapp.com',
    'pdf.retiros.document': 'Documento',
    'pdf.retiros.totalWithdrawn': 'Total retirado en el mes',
    'pdf.retiros.date': 'Fecha',
    'pdf.retiros.amount': 'Monto',
    'pdf.retiros.noData': 'No se encontraron retiros para el mes seleccionado.',

    // Usuarios — UI
    'users.title': 'Usuarios',
    'users.search': 'Buscar...',
    'users.addUser': 'Agregar usuario',
    'users.table.name': 'Nombre',
    'users.table.email': 'Email',
    'users.table.document': 'Documento',
    'users.table.status': 'Estado',
    'users.table.actions': 'Acciones',
    'users.table.active': 'Activo',
    'users.table.edit': 'Editar',
    'users.pageTitle': 'Usuarios de {company}: {count}',
    'users.pageTitleFallback': 'Usuarios: {count}',
    'users.pageSubtitle': 'Consultá y administrá los colaboradores registrados en tu empresa.',
    'users.active': 'Activo',
    'users.inactive': 'Inactivo',

    // Soporte
    'support.title': 'Atención al cliente',
    'support.description': '¿Necesitas ayuda? Cuéntanos qué sucede y te responderemos lo antes posible.',
    'support.formTitle': 'Enviar consulta',
    'support.formSubtitle': 'Completá los campos y nuestro equipo te responderá a la brevedad.',
    'support.subjectLabel': 'Título del problema',
    'support.subjectPlaceholder': 'Ej: Problema con la suscripción',
    'support.detailLabel': 'Descripción del problema',
    'support.detailPlaceholder': 'Describe detalladamente el problema que estás experimentando...',
    'support.submit': 'Enviar',
    'support.sending': 'Enviando...',
    'support.successTitle': '¡Enviado con éxito!',
    'support.successDesc': 'Te contactaremos a la brevedad...',
    'support.newInquiry': 'Enviar otra consulta',
    'support.contactHint': '¿Necesitás ayuda urgente? Escribinos a',
    'support.error': 'Error al enviar la consulta.',

    // Comprobantes
    'receipts.title': 'Comprobantes',
    'receipts.download': 'Descargar',
    'receipts.noData': 'No hay comprobantes disponibles.',

    // Adjuntar comprobante de pago
    'subirComprobante.pageTitle': 'Adjuntar comprobante de pago a PayFlex',
    'subirComprobante.pageSubtitle': 'Adjuntá el comprobante de pago para registrar la transferencia a PayFlex.',

    // Subir Excel
    'bulkUpload.pageTitle': 'Adjuntar Planilla de Usuarios',
    'bulkUpload.pageSubtitle': 'Subí la planilla con los datos de los usuarios de tu empresa.',
    'bulkUpload.dropzone': 'Arrastrá y soltá un archivo aquí, o hacé clic para seleccionar uno',
    'bulkUpload.selectedFile': 'Archivo seleccionado:',
    'bulkUpload.uploadBtn': 'Subir archivo',
    'bulkUpload.dialogTitle': 'Confirmación de carga',
    'bulkUpload.dialogText': '¿Estás seguro que quieres subir este archivo?',
    'bulkUpload.confirm': 'Confirmar',
    'bulkUpload.cancel': 'Cancelar',
    'bulkUpload.downloadTemplateHint': 'Descargá la planilla de prueba con el formato correcto antes de cargar usuarios.',
    'bulkUpload.downloadTemplate': 'Descargar plantilla',

    // Historial
    'history.title': 'Historial de acciones',
    'history.noData': 'No hay acciones registradas.',
    'history.table.action': 'Acción',
    'history.table.date': 'Fecha',
    'history.table.user': 'Usuario',

    // Común
    'common.loading': 'Cargando...',
    'common.error': 'Error',
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.close': 'Cerrar',
    'common.save': 'Guardar',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.search': 'Buscar',
    'common.filter': 'Filtrar',
    'common.all': 'Todos',
    'common.done': 'Listo',
    'common.accept': 'Aceptar',
    'common.apply': 'Aplicar',
    'common.saving': 'Guardando...',
    'common.select': 'Seleccionar',
    'common.of': 'de',

    // Modal retiros
    'withdrawals.modal.section': 'Retiros',
    'withdrawals.modal.title': 'Desglose del período',
    'withdrawals.modal.movement': 'movimiento',
    'withdrawals.modal.movements': 'movimientos',
    'withdrawals.modal.movementsLabel': 'Movimientos',
    'withdrawals.modal.totalMonth': 'Total del mes',

    // PDF retiros extra
    'pdf.retiros.hour': 'Hora',

    // Agregar usuario
    'users.add.title': 'Agregar usuario',
    'users.add.pageSubtitle': 'Completá los datos para dar de alta un nuevo colaborador.',
    'users.add.firstName': 'Primer Nombre',
    'users.add.lastName': 'Primer Apellido',
    'users.add.document': 'Documento de identidad',
    'users.add.documentOptional': 'Documento de identidad (Opcional)',
    'users.add.documentOptionalHint': 'Opcional. Podés dejarlo vacío.',
    'users.add.documentPlaceholderUs': 'Ej: licencia o SSN',
    'users.add.phoneOptional': 'Número celular (Opcional)',
    'users.add.phoneOptionalHint': 'Opcional. Podés dejarlo vacío.',
    'users.add.bank': 'Banco (Opcional)',
    'users.add.accountNumber': 'Número de cuenta (opcional)',
    'users.add.accountNumberLabel': 'Número de cuenta (Opcional)',
    'users.add.accountHint': 'Ingrese el número de cuenta',
    'users.add.netSalary': 'Sueldo neto (Opcional)',
    'users.add.withholdings': 'Retenciones (Opcional)',
    'users.add.addWithholding': 'Agregar retención',
    'users.add.createBtn': 'Crear usuario',
    'users.add.confirm.title': 'Confirmación de creación de usuario',
    'users.add.confirm.text': '¿Estás seguro que quieres crear este usuario?',
    'users.add.success.title': 'Éxito',
    'users.add.continue': 'Continuar',
    'users.add.netSalaryExample': 'Ejemplo: $30,000 (opcional)',
    'users.add.netSalaryExampleUs': 'Ejemplo: $4,000 (opcional)',

    // Usuarios — tabla
    'users.of': 'de',
    'users.search': 'Buscar por nombre o documento...',
    'users.active.badge': 'activo',
    'users.inactive.badge': 'inactivo',
    'users.filter.title': 'Filtrar usuarios',
    'users.filter.all': 'Todos los usuarios',
    'users.filter.active': 'Solo activos',
    'users.filter.inactive': 'Solo inactivos',

    // Toggle activo/inactivo modal
    'users.toggle.title': 'Confirmación de cambio de estado',
    'users.toggle.activate': 'activar',
    'users.toggle.deactivate': 'desactivar',
    'users.toggle.question': '¿Estás seguro que quieres {action} a este usuario?',

    // Modal edición usuario
    'users.edit.subtitle': 'Modificá la información personal, sueldo mensual y retenciones del colaborador',
    'users.edit.personalInfo': 'Información Personal',
    'users.edit.firstName': 'Nombre',
    'users.edit.secondName': 'Segundo Nombre (Opcional)',
    'users.edit.lastName': 'Apellido',
    'users.edit.secondLastName': 'Segundo Apellido (Opcional)',
    'users.edit.document': 'Documento',
    'users.edit.phone': 'Número celular',
    'users.edit.gender': 'Género',
    'users.edit.seasonal': 'Zafral',
    'users.edit.monthlySalary': 'Sueldo mensual',
    'users.edit.netSalary': 'Sueldo neto',
    'users.edit.enterSalary': 'Introducir sueldo neto',
    'users.edit.withholdings': 'Retenciones',
    'users.edit.type': 'Tipo',
    'users.edit.concept': 'Concepto',
    'users.edit.amount': 'Importe',
    'users.edit.month': 'Mes',
    'users.edit.year': 'Año',
    'users.edit.addWithholding': 'Agregar retención +',
    'users.edit.liquidSalary': 'Sueldo líquido:',
    'users.edit.requestChange': 'Solicitar cambio',
    'users.edit.saving': 'Guardando...',

    // Modal confirmación solicitud
    'users.confirm.title': 'Confirmar Solicitud de Cambio',
    'users.confirm.noChanges': 'No se detectaron cambios en los datos del usuario.',
    'users.confirm.pleaseModify': 'Por favor, modifica al menos un campo antes de solicitar el cambio.',
    'users.confirm.question': '¿Estás seguro que quieres solicitar el cambio de datos para',
    'users.confirm.dataToModify': 'Datos a modificar:',
    'users.confirm.pendingApproval': 'Esta solicitud será enviada para aprobación.',
    'users.confirm.btn': 'Confirmar Solicitud',

    // Modal éxito
    'users.success.title': 'Solicitud Creada Exitosamente',
    'users.success.pending': 'Pendiente de aprobación.',

    // Géneros
    'users.gender.male': 'Masculino',
    'users.gender.female': 'Femenino',
    'users.gender.other': 'Otro',

    // Zafral
    'users.seasonal.yes': 'Sí',
    'users.seasonal.no': 'No',

    // Tipos retención
    'users.retention.legal': 'Legal (BPS, FONASA, FRL, IRPF)',
    'users.retention.financial': 'Financiera (cooperativas, préstamos, tarjetas)',
    'users.retention.health': 'Mutualista / Seguro médico',
    'users.retention.union': 'Sindicato',
    'users.retention.embargo': 'Embargo judicial',
    'users.retention.other': 'Otro',

    // Historial acciones
    'history.pageTitle': 'Acciones Realizadas',
    'history.pageSubtitle': 'Registro de actividad de tu empresa en la plataforma',
    'history.col.officer': 'Funcionario',
    'history.col.action': 'Acción',
    'history.col.details': 'Detalles',
    'history.col.date': 'Fecha',
    'history.userNotFound': 'Usuario no encontrado',
    'history.noMatchingFilters': 'No hay registros que coincidan con los filtros seleccionados.',
    'history.noActionsCompany': 'No hay acciones registradas para esta empresa.',

    // Filtros historial
    'history.filter.officer': 'Funcionario',
    'history.filter.actionType': 'Tipo de acción',
    'history.filter.from': 'Desde',
    'history.filter.to': 'Hasta',
    'history.filter.allOfficers': 'Todos los funcionarios',
    'history.filter.allActions': 'Todas las acciones',
    'history.filter.chooseDate': 'Elegir fecha',

    // Comprobantes
    'comprobantes.title': 'Descargar Comprobantes',
    'comprobantes.pageSubtitle': 'Descargá los comprobantes de retiros por mes y año.',
    'comprobantes.month': 'Mes',
    'comprobantes.year': 'Año',
    'comprobantes.selectMonth': '-- Selecciona un mes --',
    'comprobantes.selectYear': '-- Selecciona un año --',
    'comprobantes.download': 'Descargar Archivos',
    'comprobantes.downloading': 'Descargando',
    'comprobantes.noWithdrawals.title': 'Sin retiros para descargar',
    'comprobantes.noWithdrawals.desc': 'No se encontraron retiros para el mes seleccionado.',
    'comprobantes.noWithdrawals.ok': 'Entendido',
    'comprobantes.fileSuffix': 'Retiros',
    'comprobantes.excel.sheetName': 'Historial',
    'comprobantes.excel.title': 'RETIROS {month} - {company}',
    'comprobantes.excel.fullName': 'Nombre completo',
    'comprobantes.excel.amountWithdrawn': 'Monto retirado',
    'comprobantes.excel.date': 'Fecha',
    'comprobantes.excel.total': 'Total',
    'comprobantes.excel.lateFee': 'Mora',
    'comprobantes.excel.grandTotal': 'TOTAL GENERAL',
    'comprobantes.excel.paymentNote':
      'A efectuar en cuenta Itaú 1976430, a nombre de PAYFLEX SAS, antes del día 7 de {month} del {year}',
    'comprobantes.excel.legalNote':
      'PayFlex está constituída como S.A.S. RUT 219712150017. Razón Social: PAYFLEX SAS',
    'comprobantes.excel.unknownUser': 'Usuario {id}',
  },

  en: {
    // Months
    'month.1': 'January',
    'month.2': 'February',
    'month.3': 'March',
    'month.4': 'April',
    'month.5': 'May',
    'month.6': 'June',
    'month.7': 'July',
    'month.8': 'August',
    'month.9': 'September',
    'month.10': 'October',
    'month.11': 'November',
    'month.12': 'December',
    'day': 'Day',

    // Login layout — left panel
    'login.leftTitle': 'Centralized management of the PayFlex App for companies.',
    'login.leftSubtitle':
      'Designed for the day-to-day work of those who work alongside PayFlex. Manage your team and more from one place.',
    'login.internalUse': 'Internal use',
    'login.brandLabel': 'Companies',

    // Login form
    'login.title': 'Sign in',
    'login.subtitle': 'Use your admin account email and password.',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.passwordPlaceholder': 'password',
    'login.showPassword': 'Show password',
    'login.hidePassword': 'Hide password',
    'login.submit': 'Sign in',
    'login.loading': 'Signing in…',
    'login.troubleText': 'Having trouble signing in?',
    'login.language': 'Language',

    // Login errors
    'login.error.emptyEmail': 'Please enter your admin account email.',
    'login.error.emptyPassword': 'Please enter your password.',
    'login.error.noPermission': "You don't have permission to access.",

    // Dashboard
    'dashboard.welcome.male': 'Welcome',
    'dashboard.welcome.female': 'Welcome',
    'dashboard.welcome': 'Welcome',
    'dashboard.subtitle': 'Here you will see all your reports',
    'dashboard.activeUsers': 'active users',
    'dashboard.withdrawnThisMonth': 'withdrawn this month',
    'dashboard.withdrawnIn': 'withdrawn in {month}',
    'dashboard.withdrawalCount': 'withdrawal count',
    'dashboard.avgWithdrawal': 'average withdrawal',
    'dashboard.chartTitle': 'Withdrawals - {month} {year}',

    // Navigation (Sidenav)
    'nav.home': 'Home',
    'nav.users': 'Users',
    'nav.withdrawals': 'Withdrawals',
    'nav.addUsersSection': 'Add Users',
    'nav.addUser': 'Add user',
    'nav.bulkUpload': 'Bulk upload',
    'nav.receiptsSection': 'Payment receipts',
    'nav.attachReceipt': 'Attach receipt',
    'nav.downloadReceiptSection': 'Withdrawal receipts',
    'nav.downloadReceipt': 'Download receipt',
    'nav.historySection': 'History',
    'nav.actionHistory': 'Action history',
    'nav.helpSection': 'Help',
    'nav.support': 'Customer support',
    'nav.settings': 'Settings',
    'nav.settingsSection': 'Configuration',

    // Logout
    'logout.button': 'Sign out',
    'logout.dialog.title': 'Sign out',
    'logout.dialog.text': 'Are you sure you want to sign out? You will need to log in again to access the\npanel.',
    'logout.loading': 'Signing out…',
    'logout.loadingDesc': 'We are securely signing you out.',

    // Session start (loading screen)
    'session.loadingDesc': 'We are preparing your access to the panel.',
    'session.errorTitle': 'Could not sign in',
    'session.errorRedirect': 'You will be redirected to sign in in a few seconds.',

    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'Customize your panel experience.',
    'settings.changePhoto': 'Change profile photo',
    'settings.photoError': 'Could not update photo. Please try again.',
    'settings.languageSection': 'Language',
    'settings.languageDesc': 'Select the language for the panel and generated files.',
    'settings.languageSpanish': 'Español',
    'settings.languageEnglish': 'English',
    'settings.save': 'Save changes',
    'settings.saved': 'Saved successfully',
    'settings.saving': 'Saving...',
    'settings.errorSaving': 'Error saving. Applied locally.',
    'settings.actionHistory': 'Action history',
    'settings.actionHistoryDesc': 'View the log of all your actions in the panel.',

    // Withdrawals — UI
    'withdrawals.titleThisMonth': 'This month\'s withdrawals',
    'withdrawals.titleOf': '{month} withdrawals',
    'withdrawals.pageSubtitle': 'View withdrawals made by your team in the selected period.',
    'withdrawals.search': 'Search by name or document...',
    'withdrawals.month': 'Month',
    'withdrawals.year': 'Year',
    'withdrawals.downloadPdf': 'Download PDF',
    'withdrawals.noData': 'No withdrawals this month',
    'withdrawals.table.name': 'Name',
    'withdrawals.table.document': 'Document',
    'withdrawals.table.amount': 'Total Withdrawn',
    'withdrawals.table.movements': 'Movements',
    'withdrawals.table.date': 'Date',
    'withdrawals.table.status': 'Status',
    'withdrawals.viewBtn': 'View withdrawals',

    // PDF Withdrawals
    'pdf.retiros.title': 'Withdrawal history for {month}',
    'pdf.retiros.support': 'PayFlex | support@payflexapp.com',
    'pdf.retiros.document': 'Document',
    'pdf.retiros.totalWithdrawn': 'Total withdrawn for the month',
    'pdf.retiros.date': 'Date',
    'pdf.retiros.amount': 'Amount',
    'pdf.retiros.noData': 'No withdrawals found for the selected month.',

    // Users — UI
    'users.title': 'Users',
    'users.search': 'Search...',
    'users.addUser': 'Add user',
    'users.table.name': 'Name',
    'users.table.email': 'Email',
    'users.table.document': 'Document',
    'users.table.status': 'Status',
    'users.table.actions': 'Actions',
    'users.table.active': 'Active',
    'users.table.edit': 'Edit',
    'users.pageTitle': "{company}'s Users: {count}",
    'users.pageTitleFallback': 'Users: {count}',
    'users.pageSubtitle': 'View and manage employees registered with your company.',
    'users.active': 'Active',
    'users.inactive': 'Inactive',

    // Support
    'support.title': 'Customer support',
    'support.description': 'Need help? Tell us what\'s happening and we\'ll get back to you as soon as possible.',
    'support.formTitle': 'Submit a request',
    'support.formSubtitle': 'Fill in the fields below and our team will get back to you shortly.',
    'support.subjectLabel': 'Problem title',
    'support.subjectPlaceholder': 'E.g., Subscription issue',
    'support.detailLabel': 'Problem description',
    'support.detailPlaceholder': 'Describe in detail the issue you are experiencing...',
    'support.submit': 'Send',
    'support.sending': 'Sending...',
    'support.successTitle': 'Sent successfully!',
    'support.successDesc': 'We\'ll get back to you shortly...',
    'support.newInquiry': 'Send another inquiry',
    'support.contactHint': 'Need urgent help? Email us at',
    'support.error': 'Error sending the query.',

    // Receipts
    'receipts.title': 'Receipts',
    'receipts.download': 'Download',
    'receipts.noData': 'No receipts available.',

    // Attach payment receipt
    'subirComprobante.pageTitle': 'Attach payment receipt to PayFlex',
    'subirComprobante.pageSubtitle': 'Attach your payment receipt to record the transfer to PayFlex.',

    // Bulk upload
    'bulkUpload.pageTitle': 'Upload Users Spreadsheet',
    'bulkUpload.pageSubtitle': 'Upload the spreadsheet with your company users data.',
    'bulkUpload.dropzone': 'Drag and drop a file here, or click to select one',
    'bulkUpload.selectedFile': 'Selected file:',
    'bulkUpload.uploadBtn': 'Upload file',
    'bulkUpload.dialogTitle': 'Upload confirmation',
    'bulkUpload.dialogText': 'Are you sure you want to upload this file?',
    'bulkUpload.confirm': 'Confirm',
    'bulkUpload.cancel': 'Cancel',
    'bulkUpload.downloadTemplateHint': 'Download the sample spreadsheet with the correct format before uploading users.',
    'bulkUpload.downloadTemplate': 'Download template',

    // History
    'history.title': 'Action history',
    'history.noData': 'No actions recorded.',
    'history.table.action': 'Action',
    'history.table.date': 'Date',
    'history.table.user': 'User',

    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.close': 'Close',
    'common.save': 'Save',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.all': 'All',
    'common.done': 'Done',
    'common.accept': 'Accept',
    'common.apply': 'Apply',
    'common.saving': 'Saving...',
    'common.select': 'Select',
    'common.of': 'of',

    // Withdrawal modal
    'withdrawals.modal.section': 'Withdrawals',
    'withdrawals.modal.title': 'Period breakdown',
    'withdrawals.modal.movement': 'movement',
    'withdrawals.modal.movements': 'movements',
    'withdrawals.modal.movementsLabel': 'Movements',
    'withdrawals.modal.totalMonth': 'Monthly total',

    // PDF withdrawals extra
    'pdf.retiros.hour': 'Time',

    // Add user
    'users.add.title': 'Add user',
    'users.add.pageSubtitle': 'Fill in the details to register a new employee.',
    'users.add.firstName': 'First Name',
    'users.add.lastName': 'Last Name',
    'users.add.document': 'Identity document',
    'users.add.documentOptional': 'Identity document (Optional)',
    'users.add.documentOptionalHint': 'Optional. You can leave it blank.',
    'users.add.documentPlaceholderUs': 'e.g. license or SSN',
    'users.add.phoneOptional': 'Phone number (Optional)',
    'users.add.phoneOptionalHint': 'Optional. You can leave it blank.',
    'users.add.bank': 'Bank (Optional)',
    'users.add.accountNumber': 'Account number (optional)',
    'users.add.accountNumberLabel': 'Account Number (Optional)',
    'users.add.accountHint': 'Enter the account number',
    'users.add.netSalary': 'Net salary (Optional)',
    'users.add.withholdings': 'Withholdings (Optional)',
    'users.add.addWithholding': 'Add withholding',
    'users.add.createBtn': 'Create user',
    'users.add.confirm.title': 'User creation confirmation',
    'users.add.confirm.text': 'Are you sure you want to create this user?',
    'users.add.success.title': 'Success',
    'users.add.continue': 'Continue',
    'users.add.netSalaryExample': 'Example: $30,000 (optional)',
    'users.add.netSalaryExampleUs': 'Example: $4,000 (optional)',

    // Users — table
    'users.of': 'of',
    'users.search': 'Search by name or document...',
    'users.active.badge': 'active',
    'users.inactive.badge': 'inactive',
    'users.filter.title': 'Filter users',
    'users.filter.all': 'All users',
    'users.filter.active': 'Active only',
    'users.filter.inactive': 'Inactive only',

    // Toggle active/inactive modal
    'users.toggle.title': 'Status change confirmation',
    'users.toggle.activate': 'activate',
    'users.toggle.deactivate': 'deactivate',
    'users.toggle.question': 'Are you sure you want to {action} this user?',

    // User edit modal
    'users.edit.subtitle': 'Edit personal information, monthly salary and withholdings for the employee',
    'users.edit.personalInfo': 'Personal Information',
    'users.edit.firstName': 'First Name',
    'users.edit.secondName': 'Second Name (Optional)',
    'users.edit.lastName': 'Last Name',
    'users.edit.secondLastName': 'Second Last Name (Optional)',
    'users.edit.document': 'Document',
    'users.edit.phone': 'Phone number',
    'users.edit.gender': 'Gender',
    'users.edit.seasonal': 'Seasonal',
    'users.edit.monthlySalary': 'Monthly salary',
    'users.edit.netSalary': 'Net salary',
    'users.edit.enterSalary': 'Enter net salary',
    'users.edit.withholdings': 'Withholdings',
    'users.edit.type': 'Type',
    'users.edit.concept': 'Concept',
    'users.edit.amount': 'Amount',
    'users.edit.month': 'Month',
    'users.edit.year': 'Year',
    'users.edit.addWithholding': 'Add withholding +',
    'users.edit.liquidSalary': 'Net salary:',
    'users.edit.requestChange': 'Request change',
    'users.edit.saving': 'Saving...',

    // Change request confirmation modal
    'users.confirm.title': 'Confirm Change Request',
    'users.confirm.noChanges': 'No changes were detected in the user data.',
    'users.confirm.pleaseModify': 'Please modify at least one field before requesting the change.',
    'users.confirm.question': 'Are you sure you want to request the data change for',
    'users.confirm.dataToModify': 'Data to modify:',
    'users.confirm.pendingApproval': 'This request will be sent for approval.',
    'users.confirm.btn': 'Confirm Request',

    // Success modal
    'users.success.title': 'Request Created Successfully',
    'users.success.pending': 'Pending approval.',

    // Genders
    'users.gender.male': 'Male',
    'users.gender.female': 'Female',
    'users.gender.other': 'Other',

    // Seasonal
    'users.seasonal.yes': 'Yes',
    'users.seasonal.no': 'No',

    // Withholding types
    'users.retention.legal': 'Legal (BPS, FONASA, FRL, IRPF)',
    'users.retention.financial': 'Financial (cooperatives, loans, cards)',
    'users.retention.health': 'Health insurance / Mutual',
    'users.retention.union': 'Union',
    'users.retention.embargo': 'Court embargo',
    'users.retention.other': 'Other',

    // Action history
    'history.pageTitle': 'Actions Performed',
    'history.pageSubtitle': 'Activity log of your company on the platform',
    'history.col.officer': 'Officer',
    'history.col.action': 'Action',
    'history.col.details': 'Details',
    'history.col.date': 'Date',
    'history.userNotFound': 'User not found',
    'history.noMatchingFilters': 'No records match the selected filters.',
    'history.noActionsCompany': 'No actions recorded for this company.',

    // History filters
    'history.filter.officer': 'Officer',
    'history.filter.actionType': 'Action type',
    'history.filter.from': 'From',
    'history.filter.to': 'To',
    'history.filter.allOfficers': 'All officers',
    'history.filter.allActions': 'All actions',
    'history.filter.chooseDate': 'Choose date',

    // Receipts download
    'comprobantes.title': 'Download Receipts',
    'comprobantes.pageSubtitle': 'Download withdrawal receipts by month and year.',
    'comprobantes.month': 'Month',
    'comprobantes.year': 'Year',
    'comprobantes.selectMonth': '-- Select a month --',
    'comprobantes.selectYear': '-- Select a year --',
    'comprobantes.download': 'Download Files',
    'comprobantes.downloading': 'Downloading',
    'comprobantes.noWithdrawals.title': 'No withdrawals to download',
    'comprobantes.noWithdrawals.desc': 'No withdrawals found for the selected month.',
    'comprobantes.noWithdrawals.ok': 'Got it',
    'comprobantes.fileSuffix': 'Withdrawals',
    'comprobantes.excel.sheetName': 'Withdrawals',
    'comprobantes.excel.title': 'WITHDRAWALS {month} - {company}',
    'comprobantes.excel.fullName': 'Full name',
    'comprobantes.excel.amountWithdrawn': 'Amount withdrawn',
    'comprobantes.excel.date': 'Date',
    'comprobantes.excel.total': 'Total',
    'comprobantes.excel.lateFee': 'Late fee',
    'comprobantes.excel.grandTotal': 'GRAND TOTAL',
    'comprobantes.excel.paymentNote':
      'To be paid to Itaú account 1976430, in the name of PAYFLEX SAS, before the 7th of {month} {year}',
    'comprobantes.excel.legalNote':
      'PayFlex is incorporated as S.A.S. RUT 219712150017. Legal name: PAYFLEX SAS',
    'comprobantes.excel.unknownUser': 'User {id}',
  },
};

export default translations;
